import styled from "styled-components";

export const StyledLink = styled("a")`
    font-weight: 400;
    color: #333;
    &:hover{
        color: #333;
    }
    &:focus{
        color: #333;
    }
    text-decoration: none;
    transition: all 0.3;
`